import getDialog from './dialog';

export default {
  getDialog,
};
